var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-grid gap-2"},[_c('button',{class:_vm.styling,on:{"click":_vm.handleClick}},[_vm._v("Vote")])])
}
var staticRenderFns = []

export { render, staticRenderFns }